import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class HotelService {

  constructor(private http:HttpClient) { }

  SearchHotel(result:any): Observable<any>{
     let headers = new HttpHeaders();
     
    // return this.http.post("http://localhost:8080/api/product/hotel/_search/v1",result,{headers:headers});
    return this.http.post(environment.API_URL+"/api/product/hotel/_search",result,{headers : headers});

    // return this.http.post(environment.API_URL+"http://localhost:8088/hotel/mmt/hotelSearch",result,{headers : headers,observe:"response"});

  }

  getcityList(type:any){
      let header = new HttpHeaders();
      let httpParam : HttpParams=new HttpParams();
      // httpParam=httpParam.append("countryId", "IN");
let request=
  {
    // "country":"IN"
    "type":type
}

      // return this.http.get("http://localhost:8088/hotel/mmt/cities",{ observe : "body", params : httpParam,responseType : "json"});

      return this.http.post(environment.API_URL+"/api/product/hotel/_cities",request,{observe : "body",responseType : "json"});

  }


  hotelDetailById(id:any){
    let headers = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("hotelId", id);
   return this.http.get("http://localhost:8088/hotel/mmt/getHotelDetail",{observe : "body", params : httpParam,responseType : "json"});

   // return this.http.post(environment.API_URL+"http://localhost:8088/hotel/mmt/hotelSearch",result,{headers : headers,observe:"response"});

 }

 generateOrder(result:any){
  let headers = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();

 return this.http.post(environment.API_URL+"/api/order/hotel/v1",result,{observe : "body",responseType : "json"});

}
generateManualsOrder(result:any){
  let headers = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();

 return this.http.post(environment.API_URL+"/api/order/hotel/v1/manuals",result,{observe : "body",responseType : "json"});

}
 

 hotelDetailByDetail(request:any){
  let headers = new HttpHeaders();
  // let httpParam : HttpParams=new HttpParams();
  // httpParam=httpParam.append("hotelId", id);
//  return this.http.post("http://localhost:8088/hotel/mmt/hotel",request,{observe : "body",responseType : "json"});
 return this.http.post(environment.API_URL+"/api/product/hotel/_hotelDetails",request,{observe : "body",responseType : "json"});

 // return this.http.post(environment.API_URL+"http://localhost:8088/hotel/mmt/hotelSearch",result,{headers : headers,observe:"response"});

}

hotelreprice(request:any){
  let headers = new HttpHeaders();
  // let httpParam : HttpParams=new HttpParams();
  // httpParam=httpParam.append("hotelId", id);
//  return this.http.post("http://localhost:8088/hotel/mmt/reprice",request,{observe : "body",responseType : "json"});
return this.http.post(environment.API_URL+"/api/order/hotel/details/v1/"+request,{observe : "body",responseType : "json"});

 // return this.http.post(environment.API_URL+"http://localhost:8088/hotel/mmt/hotelSearch",result,{headers : headers,observe:"response"});

}
OrderId(request:any,OrderId:any){
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
    // return this.http.post("http://localhost:8088/hotel/mmt/book",request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
    return this.http.post(environment.API_URL+"/api/order/hotel/v1/"+OrderId,request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  

}
OrderManualId(request:any,OrderId:any){
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
    return this.http.post(environment.API_URL+"/api/order/hotel/v1/manuals/"+OrderId,request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  

}
hotelManualreprice(request:any){
  let headers = new HttpHeaders();
return this.http.post(environment.API_URL+"/api/order/hotel/details/v1/manuals/"+request,{observe : "body",responseType : "json"});


}
hotelManualBooking(OrderId:any){
 

  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
    return this.http.post(environment.API_URL+"/api/order/hotel/book/v1/manuals/"+OrderId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  

}

hotelBooking(OrderId:any){
 

  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
    // return this.http.post("http://localhost:8088/hotel/mmt/book",request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
    // return this.http.post(environment.API_URL+"/api/product/hotel/_book",request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
    return this.http.post(environment.API_URL+"/api/order/hotel/book/v1/"+OrderId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  

}
downloadPdf(orderId:any){
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
  httpParam=httpParam.append("orderId", orderId);
    httpParam=httpParam.append("invoiceLabel", 'C');
    return this.http.get( environment.API_URL+"/api/order/hotel/voucher/v1" ,{ observe : "body", params : httpParam,responseType : "blob"})  
}

hotelValidateBookingId(request:any){
 
  let httpParam : HttpParams=new HttpParams();
    return this.http.post(environment.API_URL+"/api/order/hotel/preorder/validate/booking",request ,{ observe : "body", params : httpParam,responseType : "json"})  

}
// hotel/preorder/validate/booking
}